import jss from 'jss';

const styles = {
  titleContainer: {
    marginBottom: 5,
    borderBottom: '1px solid rgba(240, 240, 240)'
  },
  title: {
    padding: 0,
    margin: '5px 0'
  },
  orContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/styles/provision-location.js